<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { getQueryString } from './utils'

export default {
    name: 'App',
    components: {},
    created() {
        var page = getQueryString('page')
        if (page) {
            this.$router.replace({ path: '/' + page })
        }
        // else {
        //     var num = Math.random() * 2
        //     console.log("num:"+num)
        //     if (num >= 1) {
        //         this.$router.replace({ path: '/indexb' })
        //     } else {
        //         this.$router.replace({ path: '/indexa' })
        //     }
        //     // this.$router.replace({ path: '/' })
        //     // this.getNumber()
        // }
        // // this.$router.replace({ path: '/detaila' })
    },
    mounted() {
        // var Height = $(window).height()
        // $('#app').css({ height: Height })
        // $(document.body).css({ position: 'absolute', left: 0, bottom: 0, height: Height + 'px' })
        // if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        //     console.log(' safari浏览器，直接写死高度')
        //     $(document.body).addClass("safari");           
        // }
    },
    methods: {}
}
</script>

<style scoped lang="scss">
#app {
    // left: 0;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // position: fixed;
    // background-color: #000;
    // /* position: relative;
    // width: 100%;
    // height: 100%; */
    // overflow-x: hidden;
    // overflow-y: hidden;
    // &.move {
    //     overflow-y: scroll;
    // }
    // ::-webkit-scrollbar {
    //     display: none;
    // }
}
</style>
